import React from 'react';

import { TimeInput } from '@gogame/components';
import { withFormField } from '@gogame/form';

import { EXPIRATION_DATE } from './constants';

const regExpTimeFromISODate = /(\d{2}):(\d{2})/g;

const defaultTimeValue = '00:00';

const normalizeTimeValue = (value) =>
  value ? value.replace(/[A-Z]/g, '0') : defaultTimeValue;

export default withFormField({
  name: EXPIRATION_DATE,
  padding: 0,
})(({ value, onChange }) => {
  const handleChange = React.useCallback(
    (e, timeValue) => {
      onChange(
        e,
        value?.replace(regExpTimeFromISODate, normalizeTimeValue(timeValue))
      );
    },
    [value]
  );

  return (
    <TimeInput
      label={'Time'}
      value={value?.match(regExpTimeFromISODate)[0]}
      placeholder={defaultTimeValue}
      onChange={handleChange}
      disabled={!value}
    />
  );
});
